import { render } from "./authUpLoad.vue?vue&type=template&id=88f0561a&scoped=true"
import script from "./authUpLoad.vue?vue&type=script&lang=js"
export * from "./authUpLoad.vue?vue&type=script&lang=js"

import "./authUpLoad.vue?vue&type=style&index=0&id=88f0561a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_FAnl/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f0561a"]])

export default __exports__